<template>
  <div>
    <div class="row" v-if="!checked">
      <div class="col-xs-12 text-center">
        <h1>Choose A File</h1>
        <div class="form-inline">
          <div class="form-group">
            <input class="form-control" v-model="nameToCheck" type="text" placeholder="Enter Name">
            <button class="btn btn-primary" @click="retrieveFile" :disabled="nameToCheck == ''">Submit</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="checked && !exists">
      <div class="col-xs-12 text-center">          
        <h1>{{ nameToCheck }} Does Not Exists</h1>
        <button class="btn btn-primary" @click="createNewDocument">Create {{ nameToCheck }}</button>
        <button class="btn btn-primary" @click="reset">Submit Other</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions } from "vuex";
export default {
  data() {
    return {
      nameToCheck: "",
      checked: false,
    };
  },
  methods: {
    ...mapActions(["setDocument"]),
    retrieveFile() {
      var vm = this;
      this.$http
        .get("/peeb/retrieveByName.php", {
          params: {
            name: this.nameToCheck
          }
        })
        .then(function(response) {
          if (response.data) {
            vm.$store.dispatch("setDocument", response.data);
          } else {
            vm.doesNotExist();
          }
        });
    },
    doesNotExist() {
      this.checked = true;
    },
    reset() {
      this.checked = false;
      this.nameToCheck = "";
    },
    createNewDocument() {
      this.$emit('createNewDoc', this.nameToCheck);
    }
  },
  computed: {
    exists() {
      return this.$store.getters.docExists;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Landing.vue